(ns ui.components.color.hex-color
  (:require [ui.dom-globals :as dg]))

(defn view
  [{:keys [value on-change]}]
  [:div
   {:class "flex flex-row gap-2 p-2
   peer mb-0 px-3 rounded text-input-light-text
   disabled:text-disabled-regular-text text-sm
   placeholder:text-input-light-text-paler
   bg-input-light disabled:bg-disabled-regular py-2 border border-solid border-input-light-border-paler hover:border-input-light-border focus:border-input-light-border w-full value"}
   [:span
    {:class "flex w-4 h-4"
     :style {:background-color (str value)}}]
   [:input
    {:class     "border-0 focus:outline-none focus:ring-0 "
     :on-change (fn [e]
                  (on-change (dg/event-target-value e)))
     :value     value}]])
